// removed by extract-text-webpack-plugin
module.exports = {"root":"root___2V6qV"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Demo/StandardCRUD/SearchForm.less
// module id = fH8l
// module chunks = 22